import { DownOutlined } from '@ant-design/icons'
import type { FetchMeQuery, V2Organization } from '@salescore/client-api'
import { OrganizationAvatar, signInAs, useCanForFeatures } from '@salescore/client-common'
import { ellipsisFilter } from '@salescore/frontend-common'
import { useNavigate } from '@tanstack/react-router'
import { Dropdown, Menu, Space } from 'antd'
import SubMenu from 'antd/es/menu/SubMenu'
import { Array, Order, pipe, String } from 'effect'
import { t } from 'i18next'
import type { ReactElement } from 'react'

export const SiderOrganizationV2 = ({
  myIdentity,
  myUser,
}: {
  myUser: FetchMeQuery['myUser']
  myIdentity: {
    users: Array<{
      id: string
      organization: Pick<V2Organization, 'createdAt' | 'name' | 'id'>
    }>
  }
}): ReactElement => {
  const navigate = useNavigate()
  const ability = useCanForFeatures()
  const content = (
    <div className="flex w-full cursor-pointer items-center justify-between px-4 py-3 align-middle hover:bg-slate-50 hover:opacity-90">
      <div className="flex items-center align-middle">
        <OrganizationAvatar organization={myUser.organization} />
        <div className="ml-2 text-sm" style={{ width: 140, wordBreak: 'break-all' }}>
          {ellipsisFilter(myUser.organization.name, 20)}
        </div>
      </div>
      <div className="ml-1">
        <DownOutlined />
      </div>
    </div>
  )
  if (myIdentity.users.length <= 1) {
    return content
  }

  const users = pipe(
    myIdentity.users,
    Array.sortBy(
      Order.mapInput(
        Order.make<string>((a, b) => String.localeCompare(b)(a)),
        (user) => user.organization.createdAt,
      ),
    ),
  )
  return (
    <Dropdown
      placement="topRight"
      arrow={true}
      // eslint-disable-next-line sonarjs/deprecation
      overlay={
        <Menu>
          <SubMenu title={t(`他の組織にログイン`)}>
            <div className="max-h-96 overflow-y-auto">
              {users.map((user) => (
                <Menu.Item
                  key={user.id}
                  onClick={() => {
                    signInAs(user.organization, {
                      newWindow: true,
                    })
                  }}
                >
                  <Space>
                    <OrganizationAvatar organization={user.organization} />
                    {user.organization.name}
                  </Space>
                </Menu.Item>
              ))}
            </div>
          </SubMenu>
          {ability.canManageOrganizationSetting && (
            <Menu.Item
              onClick={() => {
                void navigate({
                  to: '/o/$organizationId/v2/settings',
                  params: { organizationId: myUser.organization.id },
                })
              }}
            >
              {/* spanがないと、collapsed: trueのときに1文字のみになってしまう */}
              <span>{t(`組織設定`)}</span>
            </Menu.Item>
          )}
        </Menu>
      }
      trigger={['click']}
    >
      {content}
    </Dropdown>
  )
}
